import { motion } from "framer-motion";

const CARD_COLORS = ["bg-[#f4f1ea]", "bg-[#e5b83b]", "bg-[#d96b43]"];

export const Manifesto = ({ t }) => (
  <section id="manifesto" data-testid="manifesto-section" className="halftone-light bg-[#0a0a0a] py-20 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <motion.p className="font-mono2 text-[11px] font-bold tracking-[0.4em] text-[#d96b43]" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}>
        {t.manifesto.kicker}
      </motion.p>
      <div className="mt-10 grid gap-8 lg:grid-cols-3">
        {t.manifesto.chapters.map((c, i) => (
          <motion.div
            key={c.n}
            data-testid={`manifesto-chapter-${i}`}
            className={`toon-card ${CARD_COLORS[i]} p-7 ${i % 2 ? "rotate-[1.2deg]" : "-rotate-[1.2deg]"}`}
            initial={{ opacity: 0, y: 50, rotate: i % 2 ? 5 : -5 }}
            whileInView={{ opacity: 1, y: 0, rotate: i % 2 ? 1.2 : -1.2 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.12, duration: 0.65, ease: [0.34, 1.56, 0.64, 1] }}
            whileHover={{ rotate: 0, scale: 1.02 }}
          >
            <span className="font-script text-6xl text-[#0a0a0a]" style={{ textShadow: "3px 3px 0 rgba(10,10,10,0.2)" }}>{c.n}</span>
            <h3 className="mt-4 font-script text-2xl leading-tight text-[#0a0a0a]">{c.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-[#0a0a0a]/70">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
